import React, {useEffect} from "react";
import { connect } from "react-redux";
import "../../../Dashboard/dashboard.css";
import {generateForecastRC, updateForecastRC} from "../../../../store/modules/forecastRC/actions";
import InputLabel from "@mui/material/InputLabel";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import CurrencyFormatter from "currency-formatter";
import FinancialHandler from "../../../../handlers/FinancialHandler";

const ForecastRC = ({
  currentForecastRC,
  taxes,
  appState,
  dispatchGenerateForecastRC,
  dispatchUpdateForecastRC
}) => {
  // Mounted
  useEffect(() => {
    dispatchGenerateForecastRC()
  }, [])

  // Methods
  const handleChange = (key, value) => {
    dispatchUpdateForecastRC({
      [key]: key === "analystNote" ? value : CurrencyFormatter.unformat(value, { code: "USD" })
    })
  };

  const handleOnClickGPT = async () => {
    handleChange("analystNote", "Generating...");
    const payload =
      "We are inputting the reasonable compensation for the labor contributed by all the owners and related parties. This includes adding benefits associated with their compensation. Based on these inputs, we forecast the reasonable compensation of the next year.\nHere are the company's reasonable compensation forecast data." +
      "\nSalary: " + Number(currentForecastRC?.salary).toFixed(2) + "$" +
      "\nBenefits Percentage: " + Number(currentForecastRC?.benefitsPercentage).toFixed(2) + "%" +
      "\nReasonable Compensation Estimate: " + Number(currentForecastRC?.reasonableCompensationEstimate).toFixed(2) + "$" +
      "\nGrowth Rate: " + Number(currentForecastRC?.onePlusGrowthRate * 100 - 100).toFixed(2) + "%" +
      "\nForecasted Reasonable Compensation: " + Number(currentForecastRC?.forecastedReasonableCompensation).toFixed(2) + "$" +
      "\nPlease analyze this company's forecasted reasonable compensation situation."
    const note = await FinancialHandler.fetchGPTSimpleNoteGeneration(payload);
    handleChange("analystNote", note);
  }

  return (
    <>
      <h2 className="sectionHead">Forecasted Reasonable Compensation</h2>

      <div className="dashboard-content">
          <div className="data-title-container">
            <div></div>

            <div className="data-title">
              <h6>{appState.companyData.name}</h6>
              <p>Forecasted Reasonable Compensation</p>
            </div>
          </div>

          <div className="w-full flex items-center">
            <div style={{ width: "45%", paddingRight: "10%" }}>
              <InputLabel className="text-right">Salary</InputLabel>
            </div>
            <div>
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={currentForecastRC?.salary}
                onChange={(value) => handleChange("salary", value)}
              />
            </div>
          </div>

          <div className="w-full flex items-center mt-1">
            <div style={{ width: "45%", paddingRight: "10%"  }}>
              <InputLabel className="text-right">Benefits</InputLabel>
            </div>
            <div>
              <BVAInput
                size="small"
                id="rc-benefits"
                endAdornment
                endAdornmentLabel="%"
                startAdornment
                startAdornmentLabel="x"
                onChange={(value) => handleChange("benefitsPercentage", value)}
                value={currentForecastRC?.benefitsPercentage}
              />
            </div>
          </div>

          <div className="w-full flex items-center mt-1">
            <div style={{ width: "45%", paddingRight: "10%"  }}>
              <InputLabel className="text-right">Reasonable Compensation Estimate</InputLabel>
            </div>
            <div>
              <BVAInput
                disabled
                size="small"
                id="rc-reasonableCompensationEstimate"
                startAdornment
                startAdornmentLabel="$"
                value={currentForecastRC?.reasonableCompensationEstimateFormatted}
              />
            </div>
          </div>

          <div className="w-full flex items-center mt-1">
            <div style={{ width: "45%", paddingRight: "10%"  }}>
              <InputLabel className="text-right">1 + Growth Rate</InputLabel>
            </div>
            <div>
              <BVAInput
                disabled
                size="small"
                id="rc-growthRate"
                startAdornment
                startAdornmentLabel="x"
                value={Number((1 + (taxes.growthRate / 100)).toFixed(5))}
              />
            </div>
          </div>

          <div className="w-full flex items-center mt-1">
            <div style={{ width: "45%", paddingRight: "10%" }}>
              <InputLabel className="text-right">
                Forecasted Reasonable Compensation
              </InputLabel>
            </div>
            <div>
              <BVAInput
                disabled
                size="small"
                id="rc-forcastedValue"
                startAdornment
                startAdornmentLabel="$"
                value={currentForecastRC?.forecastedReasonableCompensationFormatted}
              />
            </div>
          </div>

          <div className="data-bottom mt-10 mr-20 pr-20" style={{ width: "45em" }}>
            <h5 className="noteHead">Analyst Note&nbsp;&nbsp;&nbsp;<button onClick={() => handleOnClickGPT()}>🤖</button></h5>
            <textarea
              className="analystNote"
              rows={3}
              value={currentForecastRC?.analystNote}
              onChange={(e) => handleChange("analystNote", e.target.value)}
            />
          </div>
        </div>
    </>
  );
};

const mapStateToProps = (state) => ({
    currentForecastRC: state.forecastRC.currentForecastRC,
    taxes: state.taxes,
    appState: state.appState,
})

const mapDispatchToProps = (dispatch) => ({
  dispatchGenerateForecastRC() {
    const forecastRC = dispatch(generateForecastRC())
    return forecastRC
  },

  dispatchUpdateForecastRC({ salary, benefitsPercentage, analystNote }) {
    dispatch(updateForecastRC({ salary, benefitsPercentage, analystNote }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ForecastRC);
